import React from "react";
type ButtonProps = {
  href?: string;
  children: React.ReactNode;
  className?: string;
  type?: "button" | "submit";
  disabled?: boolean;
  onClick?: () => void;
};
const base = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-gold px-6 py-3 text-sm font-semibold text-ink shadow-soft transition-[background-color,transform] duration-150 ease-out hover:bg-gold-dark active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-ink disabled:cursor-not-allowed disabled:opacity-70";
export function Button({
  href,
  children,
  className = "",
  type = "button",
  disabled,
  onClick
}: ButtonProps) {
  if (href) {
    return <a href={href} className={`${base} ${className}`} onClick={onClick} data-id="element-30" data-mp="23at63ix4pum7">
        {children}
      </a>;
  }
  return <button type={type} disabled={disabled} onClick={onClick} className={`${base} ${className}`} data-id="element-31" data-mp="30sbb63ltx48z">
      {children}
    </button>;
}